import React from 'react';
import './detallerubro.css';
import { rubros } from '../../json/rubros';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';

const DetalleRubro = () => {
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { nombre } = useParams();
  const rubro = rubros.find((rubro) => rubro.nombre === nombre);

  return (
    <div className='container container_detalle_rubro'>
      <div className='row'>
        <div className='col-12'>
          <div className='rubro_titulo'>
            <h3 className='title'>{rubro.nombre}</h3>
            <hr className='hr-gob' />
          </div>
        </div>
      </div>
      <div className='row'>
        {
          rubro.formatos.map((formato, index) => {
            //ETH 13/06/2023 Condición para url's
            let urlXLSX;
            let urlHTML;
            if(formato.xlsx_liga == undefined){
              urlXLSX = "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir1/48_Rubros/xlsx/a69_" + formato.xlsx + "CECULTAH.xlsx";
            }else {
              urlXLSX = formato.xlsx_liga;
            }
            if(formato.htm_liga == undefined){
              urlHTML = "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir1/48_Rubros/htm/a69_" + formato.html + "CECULTAH.htm";
            }else {
              urlHTML = formato.htm_liga;
            }
            //ETH 13/06/2023 Condición para url's
            //este es el codigo orginal | const urlXLSX = "/Transparencia/xlsx/a69_" + formato.xlsx + "CECULTAH.xlsx";
            //este es el codigo orginal | const urlHTML = "/Transparencia/htm/a69_" + formato.html + "CECULTAH.htm";
            return (
              <div key={ index } className='col-md-4 col-12'>
                <div className='rubro_container_detalle'>
                  <div className='detalle_rubro_nombre'>
                    <h5>{ formato.nombre }</h5>
                  </div>
                  <div className='detalle_rubro_enlaces'>
                    <a href={ urlXLSX } target="_blank">XLSX</a>
                    <a href={ urlHTML } target="_blank">Ver Tabla</a>
                  </div>
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

export default DetalleRubro;
